import { render } from "./PRadio.vue?vue&type=template&id=531bb426&scoped=true&lang=pug"
import script from "./PRadio.vue?vue&type=script&lang=js"
export * from "./PRadio.vue?vue&type=script&lang=js"

import "./PRadio.vue?vue&type=style&index=0&id=531bb426&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531bb426"],['__file',"src/common/inputs/PRadio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "531bb426"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('531bb426', __exports__)) {
    api.reload('531bb426', __exports__)
  }
  
  module.hot.accept("./PRadio.vue?vue&type=template&id=531bb426&scoped=true&lang=pug", () => {
    api.rerender('531bb426', render)
  })

}


export default __exports__